import { Form, Input } from 'antd';

export default function PasswordInput(props) {
   const { inputRef, id, size, label, placeholder, name, error, helperText, rules, dependencies, formField, ...rest } =
      props;
   const assignRef = (antdRef) => {
      if (!inputRef) return;
      inputRef.current = antdRef ? antdRef.input : null;
   };
   return (
      <Form.Item
         {...(formField !== undefined ? { name: formField, rules, dependencies } : {})}
         label={label || 'Password'}
         htmlFor={id}
         required
         validateStatus={error ? 'error' : ''}
         help={helperText}
         colon={false}
         labelCol={{ span: 24 }}
         wrapperCol={{ span: 24 }}
         style={{ width: '100%', marginBottom: 0 }}
      >
         <Input.Password
            ref={assignRef}
            id={id}
            name={name || 'password'}
            placeholder={placeholder || 'password'}
            {...(size !== undefined ? { size } : {})}
            {...rest}
         />
      </Form.Item>
   );
}
